/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraVulnerabilityAWSInspectorEcrImageArchitectureQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("InfraVulnerabilityAWSInspectorEcrImageArchitectureQueryOperator");
    }

    getFixupPrototypeFunction() { return InfraVulnerabilityAWSInspectorEcrImageArchitectureQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<InfraVulnerabilityAWSInspectorEcrImageArchitectureQueryOperator>): InfraVulnerabilityAWSInspectorEcrImageArchitectureQueryOperator {
        let obj = Object.assign(new InfraVulnerabilityAWSInspectorEcrImageArchitectureQueryOperator(), model);
        InfraVulnerabilityAWSInspectorEcrImageArchitectureQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraVulnerabilityAWSInspectorEcrImageArchitectureQueryOperator>): InfraVulnerabilityAWSInspectorEcrImageArchitectureQueryOperator {
        if (!model) return null;
        return InfraVulnerabilityAWSInspectorEcrImageArchitectureQueryOperator.newInstance(<InfraVulnerabilityAWSInspectorEcrImageArchitectureQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraVulnerabilityAWSInspectorEcrImageArchitectureQueryOperator) {
        if (!obj) return;

        models.InfraVulnerabilityAWSInspectorEcrImageArchitectureQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraVulnerabilityAWSInspectorEcrImageArchitectureQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, InfraVulnerabilityAWSInspectorEcrImageArchitectureQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Matches against the start of the ECR image architecture
     */
    starts_with: string;

}
